module.exports = __webpack_public_path__ + "img/arrow-down.4be23dd7.svg";